import axios from 'axios';

export const searchDocs = async (searchTerms) => {
  const url = `${SERVICE_URL}/api/v1/admin/search`;
  return axios.post(url, searchTerms).then((response) => {
    return response.data;
  });
};

export const searchTransmitUserDocs = async (searchTerms) => {
  const url = `${SERVICE_URL}/api/v1/admin/search/transmit`;
  return axios.post(url, searchTerms).then((response) => {
    return response.data;
  });
};
